import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useWhatsappChatsHidden } from '../../hooks/useWhatsappChatsHidden';
import WabaChatsContainer from './WabaChatsContainer';

// Прямой заход на /waba-chats при скрытых чатах уводит на страницу WhatsApp.
// Пока конфигурация филиала не загружена, контейнер не монтируем: иначе он
// успеет дёрнуть API чатов до того, как станет известно, что они скрыты.
export default function WabaChatsPage() {
    const branchLoaded = useSelector(s => !!s.branchReducer?.info?.id);
    const chatsHidden = useWhatsappChatsHidden();

    if (!branchLoaded) return null;

    if (chatsHidden) return <Redirect to="/whatsapp" />;

    return <WabaChatsContainer />;
}
